import React from 'react';
import PropTypes from 'prop-types';
import styles from './simpleTwoThree.scss';
import UtrLogo from './UtrLogo';

const Rounds = () => {
    return (
        <div className={styles.frame9}>
            <div className={styles.frame10}>
                <p className={styles.p}>1 minute per time out</p>
            </div>
            <div className={styles.frame11}>
                <div className={styles.textWrapper}>1</div>
            </div>
            <div className={styles.frame11}>
                <div className={styles.textWrapper}>2</div>
            </div>
            <div className={styles.frame11}>
                <div className={styles.textWrapper}>1</div>
            </div>
            <div className={styles.frame11}>
                <div className={styles.textWrapper}>2</div>
            </div>
            <div className={styles.frame11}>
                <div className={styles.textWrapper}>1</div>
            </div>
            <div className={styles.frame11}>
                <div className={styles.textWrapper}>2</div>
            </div>
            <div className={styles.frame12} />
        </div>
    );
};

const SimpleTwoThree = ({ hasBreak, drawName, matchPosition, courtNumber, scoringFormatDisplay, displayNameOne, displayNameTwo, displayNameThree, displayNameFour }) => {
    const Header = () => {
        return (
            <div className={styles.frame}>
                <div className={styles.div}>
                    <div className={styles.frame2}>
                        <div className={styles.textWrapper}>DRAW NAME</div>
                        <div className={styles.textWrapper2}>{drawName}</div>
                    </div>
                    <div className={styles.divWrapper}>
                        <div className={styles.textWrapper}>MATCH</div>
                        <p className={styles.textWrapper2}>{matchPosition}</p>
                    </div>
                    <div className={styles.divWrapper}>
                        <div className={styles.textWrapper}>COURT</div>
                        <p className={styles.textWrapper2}>{courtNumber}</p>
                    </div>
                    <div className={styles.frame3}>
                        <div className={styles.textWrapper}>scoringFormat</div>
                        <p className={styles.textWrapper2}>{scoringFormatDisplay}</p>
                    </div>
                </div>
            </div>
        );
    };

    const SubHeader = ({ titleOne, playerOneName, titleTwo, playerTwoName }) => {
        return (
            <div className={styles.frame5}>
                <div className={styles.frame6}>
                    <div className={styles.textWrapper}>{titleOne}</div>
                    <div className={styles.textWrapper2}>{playerOneName}</div>
                </div>
                <div className={styles.frame7}>
                    <div className={styles.textWrapper}>{titleTwo}</div>
                    <div className={styles.textWrapper2}>{playerTwoName}</div>
                </div>
                <div className={styles.frame8}>
                    <div className={styles.textWrapper}>G1</div>
                </div>
                <div className={styles.frame8}>
                    <div className={styles.textWrapper}>G2</div>
                </div>
                <div className={styles.frame8}>
                    <div className={styles.textWrapper}>G3</div>
                </div>
                <div className={styles.initialsWrapper}>
                    <div className={styles.initials}>INITIALS</div>
                </div>
            </div>
        );
    };

    SubHeader.propTypes = {
        titleOne: PropTypes.string,
        titleTwo: PropTypes.string,
        playerOneName: PropTypes.string,
        playerTwoName: PropTypes.string,
    };

    SubHeader.defaultProps = {
        titleOne: '',
        titleTwo: '',
        playerOneName: '',
        playerTwoName: '',
    };

    return (
        <div className={hasBreak ? styles.simpleTwoThreeContainerBreakAfter : styles.simpleTwoThreeContainer}>
            <div className={styles.simpleTwoThree}>
                <UtrLogo style={{ marginTop: '14px' }} />
                <div className={styles.group}>
                    <Header />
                    <div className={styles.frame4}>
                        <SubHeader
                            titleOne="PL 1, TEAM 1"
                            playerOneName={displayNameOne}
                            titleTwo="PL 2, TEAM 1"
                            playerTwoName={displayNameTwo}
                        />
                        <Rounds />
                        <SubHeader
                            titleOne="PL 1, TEAM 2"
                            playerOneName={displayNameThree}
                            titleTwo="PL 2, TEAM 2"
                            playerTwoName={displayNameFour}
                        />
                        <Rounds />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SimpleTwoThree;

SimpleTwoThree.propTypes = {
    hasBreak: PropTypes.bool,
    drawName: PropTypes.string,
    matchPosition: PropTypes.string,
    courtNumber: PropTypes.string,
    scoringFormatDisplay: PropTypes.string,
    displayNameOne: PropTypes.string,
    displayNameTwo: PropTypes.string,
    displayNameThree: PropTypes.string,
    displayNameFour: PropTypes.string,
};

SimpleTwoThree.defaultProps = {
    hasBreak: true,
    drawName: '',
    matchPosition: '',
    courtNumber: '',
    scoringFormatDisplay: '',
    displayNameOne: '',
    displayNameTwo: '',
    displayNameThree: '',
    displayNameFour: '',
};
